<div style="margin-top: 50px;" class="custom-tabview">
  <p-tabView [(activeIndex)]="indexTab" [scrollable]="false" (onChange)="removerNotification($event)">
    <p-tabPanel>
      <ng-template pTemplate="header">
          <div class="order-tab-container">
            <figure class="circle-icon" [ngClass]="{'bill-icon': indexTab === 0}">
              <span class="material-icons" style="font-size:14px">receipt_long</span>
            </figure>
            <span class="text-tab">
              {{'OrderDetailTabComponent.PartyInformationTabText' | translate}}
            </span>
          </div>
        </ng-template>
        <app-import-order-bill-info
        [delivery]="delivery"
        [importer]="importOrder?.importer"
        [exporters]="order ? order.exportersInformation: []"
         (click)="changeBackgroundColor('#32CD32')"
        >
      </app-import-order-bill-info>
    </p-tabPanel>

    <p-tabPanel>
      <ng-template pTemplate="header">
        <div class="order-tab-container">
          <figure class="circle-icon" [ngClass]="{'ship-icon': indexTab === 1}">
            <span class="material-icons" style="font-size:14px">local_shipping</span>
          </figure>
          <span class="text-tab">
            {{'OrderDetailTabComponent.LoadingInfoTabText' | translate}}
          </span>
        </div>
      </ng-template>
      <app-import-order-loading-data
        [delivery]="delivery"
        >
      </app-import-order-loading-data>
    </p-tabPanel>

    <p-tabPanel [ngClass]="{'active-tab': indexTab === 2}">
      <ng-template pTemplate="header">
        <div class="order-tab-container">
          <figure class="circle-icon" [ngClass]="{'folder-icon': indexTab === 2}">
            <span class="material-icons" style="font-size:14px">description</span>
          </figure>
          <span class="text-tab">
            {{'OrderDetailTabComponent.DocumentsTabText' | translate}}
          </span>
        </div>
      </ng-template>
      <!-- <app-import-order-operation [order]="order"></app-import-order-operation> -->
      <app-import-order-documents
       [typeDocuments]="0"
       [importOrder]="importOrder"
       [details]="importOrderDetails"
       [operationDocuments]="operationDocuments"
       [forwarderDocuments]="forwarderDocuments"
       [customAgentDocuments]="customAgentDocuments"
       [invoices]="invoices"></app-import-order-documents>
    </p-tabPanel>


    <p-tabPanel [ngClass]="{'active-tab': indexTab === 3}">
      <ng-template pTemplate="header">
        <div class="order-tab-container">
          <figure class="circle-icon" [ngClass]="{'file-icon': indexTab === 3}">
            <span class="material-icons" style="font-size:14px">assignment</span>
          </figure>
          <span class="text-tab">
            {{'OrderDetailTabComponent.ReportsTabText' | translate}}
          </span>
        </div>
      </ng-template>
      <!-- <app-import-order-operation [order]="order"></app-import-order-operation> -->
      <app-import-order-documents
       [typeDocuments]="1"
       [importOrder]="importOrder"
       [qualityControlDocuments]="qualityControlDocuments"
       [productCertificateDocuments]="productCertificateDocuments"
       [exportOfferDocuments]="exportOfferDocuments"></app-import-order-documents>
    </p-tabPanel>



    <p-tabPanel [ngClass]="{'active-tab': indexTab === 4}">
      <ng-template pTemplate="header">
        <div class="order-tab-container">
          <figure class="circle-icon" [ngClass]="{'dollar-icon': indexTab === 4}">
            <span class="material-icons" style="font-size:14px">paid</span>
          </figure>
          <span class="text-tab">
            {{'OrderDetailTabComponent.PaymentsTabText' | translate}}
          </span>
        </div>
      </ng-template>
      <app-import-order-payments
      [delivery]="delivery"
      [discounts]="discounts"
      [costs]="costs"
      [directSaleProgramId]="directSaleProgramId"
      [importOrder]="order?.importOrder"
      [importOrderDetails]="importOrderDetails"
      [payments]="payments"
      [isClosedSale]="isClosedSale"
      [paymentsQualityControl]="paymentsQualityControl"
      >
      </app-import-order-payments>
    </p-tabPanel>

  </p-tabView>
</div>
